module.exports = __webpack_public_path__ + "media/images/sp/stores/hamamatsu/hamamatsu_concept_03-145308e4c871ad47781ccb9112d33e65.jpg";